import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES,
} from '../../common/constants';
import ProjectResourceSheet from './ProjectResourceSheet';

const ProjectResourceWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.PROJECT_RESOURCE_SHEET}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.PROJECT_RESOURCE_SHEET}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <ProjectResourceSheet {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default ProjectResourceWrapper;
